import { ParsedUrlQuery } from "querystring"
import { NextPageContext } from "next"
import { ABTestExperiment, activeExperiments, ExperimentId, ExperimentTag } from "../experiments"
import { NextCookieStore } from "./next-cookie-store"
import { defaultComputeNewSegmentValue, loadOrGenerateSegment } from "./segment"

export interface CookieStore<T = ExperimentId> {
    load: () => ExperimentTag<T>[]
    store: (history: ExperimentTag<T>[]) => void
}

export const assignActiveExperiments = (ctx: NextPageContext) => {
    if (!ctx.req || !ctx.res) return

    const pippo = assignExperiments(new NextCookieStore(ctx), activeExperiments)
    const overridden = overrideSegmentsFromQueryParams(pippo, ctx.query)
    return overridden
}

export const assignExperiments = <T = ExperimentId>(
    cookieStore: CookieStore<T>,
    experiments: readonly ABTestExperiment<T>[],
) => {
    const cookieHistory = cookieStore.load()

    const enabledExperiments = experiments.filter((e) => e.enabled)
    const disabledExperiments = experiments.filter((e) => !e.enabled)

    const enabledTags = enabledExperiments.reduce((acc, e) => {
        const { history } = loadOrGenerateSegment(e, defaultComputeNewSegmentValue, enabledExperiments, acc)
        return history
    }, cookieHistory)
    cookieStore.store(enabledTags)

    const disabledTags = disabledExperiments.map((e) => ({ experimentId: e.id, segmentId: "a" as const }))

    return [...enabledTags, ...disabledTags]
}

const overrideSegmentsFromQueryParams = (experimentTags: ExperimentTag[], queryParams: ParsedUrlQuery) =>
    experimentTags.map((tag) => {
        const segmentFromQuery = queryParams[`${tag.experimentId}-segment`]
        if (!segmentFromQuery) return tag

        return {
            ...tag,
            segmentId: segmentFromQuery == "b" ? "b" : "a",
        }
    })
